import { connect } from 'react-redux';
import moment from 'moment-timezone';

import LabelsView from '../../components/labels/LabelsView';
import {
  addNewLabel,
  fetchLabels,
  selectLabel,
  setLabelsCurrentDate,
  updateLabel,
} from '../../actions/labels';
import {
  getCurrentDateFromLabels,
  getLabels,
  getMyPermissions,
  getProjectZoneId,
  isLabelsModalVisible,
} from '../../reducers/analyticsApp';
import { staticPermissions } from '../../constants/authorization';
import { DATE_DAILY_FORMAT } from '../../constants/date';

const getDateInDefaultFormat = (date) => moment(date.valueOf()).format(DATE_DAILY_FORMAT);

const resizeLabel = (label, start, end) => ({
  ...label,
  duration: [getDateInDefaultFormat(start), getDateInDefaultFormat(end)],
});

const changeLabelDuration = ({ event, start, end }) => {
  const label = resizeLabel(event, start, end);
  return updateLabel(label);
};

const mapStateToProps = (state) => ({
  zoneId: getProjectZoneId(state),
  labels: getLabels(state),
  modalVisible: isLabelsModalVisible(state),
  hasPermission: getMyPermissions(state).has(staticPermissions.LABELS_MANAGE),
  currentDate: getCurrentDateFromLabels(state),
});

const mapDispatchToProps = {
  onDateSelect: (duration) => {
    const durationVar = duration
      ? [duration[0], moment(duration[1].valueOf()).subtract(1, 'day').format(DATE_DAILY_FORMAT)]
      : duration;

    return addNewLabel(durationVar);
  },
  onLabelSelect: selectLabel,
  onLabelResize: ({ event, start, end }) =>
    changeLabelDuration({
      event,
      start,
      end: moment(end.valueOf()).subtract(1, 'day').format(DATE_DAILY_FORMAT),
    }),
  fetchLabels,
  setLabelsCurrentDate,
};

export default connect(mapStateToProps, mapDispatchToProps)(LabelsView);
